<template>
    <div class="noData" :style="pad? 'padding-top:' + pad: ''">
        <div :style="imgWidth?'width:' + imgWidth:''" style="margin: 0 auto;">
            <img src="../../assets/noData.png" alt="">
        </div>
        <div>暂无数据</div>
    </div>
</template>

<script>
    export default {
        props: {
            pad: String,
            imgWidth: String
        }
    }
</script>

<style lang="scss" scoped>
    .noData {
        text-align: center;
        img {
            width: 60%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/noData/index.vue